import Avatar from "../../../../../src/components/avatar/Avatar";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Avatar,
  Playground,
  Props,
  React
};